<template>
    <v-dialog
        :content-class="`linked-content-dialog level-${index}`"
        :value="active"
        :hide-overlay="index > 0"
        @click:outside="$emit('close', linkedContent)"
        max-width="990px"
        scrollable
    >
        <v-card :class="`card-${index}`" v-if="linkedContent.body">
            <v-card-title>
                <div class="card-title-content">
                    <typo name="title-17-bold">{{ linkedContent.title }}</typo>
                    <div>
                        <v-icon @click="$emit('print', linkedContent)" class="icon">
                            mdi-printer
                        </v-icon>
                        <v-icon @click="$emit('close', linkedContent)" class="icon">
                            mdi-close
                        </v-icon>
                    </div>
                </div>
            </v-card-title>
            <v-card-text>
                <linked-content-dialog-body :body="linkedContent.body"></linked-content-dialog-body>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import Vue from "vue";
import LinkedContentDialogBody from "./LinkedContentDialogBody.vue";

export default Vue.extend({
    props: ["linkedContent", "active", "index"],
    components: { LinkedContentDialogBody },
});
</script>

<style lang="sass" scoped>

.v-card__text
    padding: $grid-gutter*2 !important
    margin: auto

.v-card__title
    background: $color-background
    word-break: break-word

.icon
    margin-left: auto
    color: $color-main

.card-title-content
    display: flex
    align-items: flex-start
    justify-content: space-between
    flex-grow: 1
</style>

<style lang="sass">
.linked-content-dialog
    position: relative
    &.level-1
        left: 13px
        top: 13px
    &.level-2
        left: 26px
        top: 26px
    &.level-3
        left: 39px
        top: 39px
</style>
